import React from "react";
import { RedocStandalone } from "redoc";
import { redocRawOptions } from './utils/opts';

const Docs = () => <RedocStandalone specUrl={`${window.location.origin}/swagger/doc.json`} options={redocRawOptions('v1')} />;

export default Docs;
